import { Navigate } from 'react-router-dom';
import {
  DRAFT_KEY,
  TERMS_STORAGE_KEY,
  FLOW_STARTED_KEY,
  FLOW_READY_FOR_PAYMENT_KEY,
} from '@/lib/flowkeys';

/** Block access if membership flow hasn't started (no draft or flag) */
export function RequireMembershipStarted({
  children,
}: {
  children: JSX.Element;
}) {
  const started =
    localStorage.getItem(FLOW_STARTED_KEY) === '1' ||
    !!localStorage.getItem(DRAFT_KEY);
  if (!started) return <Navigate to="/membership" replace />;
  return children;
}

/** Block access if terms not accepted */
export function RequireTermsAccepted({ children }: { children: JSX.Element }) {
  const accepted = localStorage.getItem(TERMS_STORAGE_KEY) === '1';
  if (!accepted) return <Navigate to="/terms" replace />;
  return children;
}

/** Block access to payment unless the flow marked ready after terms */
export function RequireReadyForPayment({
  children,
}: {
  children: JSX.Element;
}) {
  const ready = localStorage.getItem(FLOW_READY_FOR_PAYMENT_KEY) === '1';
  if (!ready) return <Navigate to="/terms" replace />;
  return children;
}
